import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { IconButton } from '@mui/material';
import classNames from 'classnames';
import useGlobalContext from 'hooks/useGlobalContext';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GTM, GTMButtons, GTMLocations } from 'utils/analytics';
import { getBodyScrollPositionY } from 'utils/dom-element-helpers';

const SCREENS_BEFORE_SHOWN = 3;

type Props = {
  location: GTMLocations;
};

const BackToTopButton = ({ location }: Props) => {
  const { t } = useTranslation();
  const { get: getFromContext } = useGlobalContext();
  const isDownloadAppBannerHidden = getFromContext('isDownloadAppBannerHidden') as boolean;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(getBodyScrollPositionY() > SCREENS_BEFORE_SHOWN * window.innerHeight);

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <IconButton
      aria-label={t('common.back-to-top')}
      tabIndex={visible ? 0 : -1}
      aria-hidden={!visible}
      onClick={() => {
        GTM.buttonClicked(GTMButtons.BACK_TO_TOP, location);
        // Move focus off the button before it hides, so keyboard users continue from the top
        const main = document.getElementById('main-container');

        main?.setAttribute('tabindex', '-1');
        main?.focus({ preventScroll: true });
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      }}
      className={classNames('back-to-top-btn', { visible, high: !isDownloadAppBannerHidden })}
    >
      <ArrowUpwardIcon />
    </IconButton>
  );
};

export default BackToTopButton;
